import jwt_decode from 'jwt-decode'

export const toLocaleDateString = date => {
  const new_date = new Date(date)

  return new_date.toLocaleDateString()
}

export const toLocaleString = date => {
  if (null === date) {
    return ''
  }
  const new_date = new Date(date)

  return new_date.toLocaleString()
}

export const getUserToken = () => {
  const user_token = sessionStorage.getItem('user_jwt')
  if (null === user_token) {
    return null
  }
  let token = jwt_decode(user_token)
  const types = token.type.split('\\')
  token.type = types[2].toLowerCase() + 's'

  return token
}

export const curr_user = {
  id: getUserToken()
}

export const parseErrorViolations = error => {
  let violations = {}
  if (undefined === error.response.data.violations)
    return {global: error.response.data['hydra:description']}

  error.response.data.violations.forEach(violation => {
    violations[violation.propertyPath] = violation.message
  })

  return violations
}



// WEBPACK FOOTER //
// ./src/services/utils.js